<template>
  <div id="app">
    <div class="wrapper" v-if="showNav">
      <nv-topbar></nv-topbar>
      <nv-head1></nv-head1>
      <router-view></router-view>
      <nv-footer></nv-footer>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import nvHead1 from './components/header1.vue'
  import nvFooter from './components/footer.vue'
  import nvTopbar from './components/topbar.vue'
  export default {
    name: 'App',
    components: {
      nvHead1,
      nvFooter,
      nvTopbar
    },
    computed: {
      showNav(){
        if(this.$route.meta!= undefined&&this.$route.meta.showNav != undefined){
          return this.$route.meta.showNav;
        }
        return true;
      }
    },
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1180px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue